import MonitoringServiceAddToRemarkModal from './monitoring-service-add-to-remark-modal.vue'
export default MonitoringServiceAddToRemarkModal
